/* Authoritative totals are optional until the backend baseline has been populated. */
document.addEventListener('alpine:init',()=>{
  Alpine.store('forumCounts',{
    enabled:false,ready:false,categories:{},topics:{},requested:{},loading:false,epoch:0,timer:null,dirty:false,
    init(){
      const root=document.querySelector('[data-forum-counts-enabled]');
      this.enabled=root?.dataset.cfAuth==='1' && root.dataset.forumCountsEnabled==='true';
      if(!this.bound){
        this.bound=true;
        window.addEventListener('modl-auth-lost',()=>this.clear());
        window.addEventListener('pagehide',()=>this.clear());
        window.addEventListener('pageshow',event=>{if(event.persisted)this.init();});
        window.addEventListener('modl-forum-counts-refresh',()=>this.schedule());
        window.addEventListener('modl-moderation-changed',event=>{if(!event.detail?.preview)this.schedule();});
        window.addEventListener('modl-moderation-state',()=>this.schedule());
        document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.schedule();});
      }
      if(this.enabled)this.schedule();
    },
    clear(){this.epoch++;clearTimeout(this.timer);this.enabled=false;this.ready=false;this.categories={};this.topics={};this.requested={};this.loading=false;this.dirty=false;},
    category(blog){return this.ready?(this.categories[blog] || {topics:0,posts:0}):{topics:'…',posts:'…'};},
    topic(blog,handle){
      const key=blog+'/'+handle;
      if(blog && handle && !this.requested[key]){this.requested[key]={blog,handle};this.schedule();}
      return this.ready?this.topics[key]:null;
    },
    schedule(){
      if(!this.enabled)return;
      if(this.loading){this.dirty=true;return;}
      clearTimeout(this.timer);this.timer=setTimeout(()=>this.refresh(),100);
    },
    async refresh(){
      if(!this.enabled || this.loading)return;
      if(document.hidden){clearTimeout(this.timer);this.timer=setTimeout(()=>this.refresh(),15000);return;}
      const epoch=this.epoch;this.loading=true;this.dirty=false;clearTimeout(this.timer);
      try{
        const refs=Object.values(this.requested),topics={};let data;
        for(let offset=0;offset<Math.max(1,refs.length);offset+=100){
          const response=await window.ModlCommunityAPI.request('/api/forum-counts',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({topics:refs.slice(offset,offset+100)})});
          if(!response.ok)throw Error('Counts unavailable');
          data=await response.json();if(epoch!==this.epoch)return;
          if(!data.ready){this.ready=false;return;}
          Object.assign(topics,data.topics);
        }
        this.categories=data.categories;this.topics=topics;this.ready=true;
      }catch{/* Keep the last saved totals during a temporary outage; never substitute capped counts. */}
      finally{if(epoch===this.epoch){this.loading=false;this.timer=setTimeout(()=>this.refresh(),this.dirty?100:15000);}}
    }
  });
});
